// Thứ tự = thứ tự hiện trên trang chủ. Hình kết quả mẫu của mỗi thẻ vẽ trong
// Home.jsx (HINH_THE), theo `id`. Thẻ có `links` hiện nhiều đường dẫn
// riêng; thẻ không có `links` dẫn thẳng vào `tool`.
export const JOURNEYS = [
  {
    id: "funds",
    number: "01",
    title: "Tìm nguồn vốn phù hợp",
    desc: "Lọc theo loại vốn và kiểm điều kiện bắt buộc của từng quỹ.",
    tool: "fund-match",
    links: [
      { label: "Đối chiếu startup của tôi", tool: "fund-match" },
      { label: "Xem danh mục nguồn vốn", to: "/nguon-von" },
    ],
    icon: "⌕",
  },
  {
    id: "capital",
    number: "02",
    title: "Tính số vốn cần gọi",
    desc: "Còn bao lâu tiền, cần gọi bao nhiêu, và cổ phần bị pha loãng ra sao.",
    tool: "runway",
    // Một thẻ gộp ba câu hỏi khác nhau từng dẫn thẳng vào công cụ runway, nên
    // người muốn tính pha loãng vào sai chỗ. Giờ mỗi câu hỏi có đường riêng.
    links: [
      { label: "Tính runway", tool: "runway" },
      { label: "Cần gọi bao nhiêu vốn?", tool: "raise-planner" },
      { label: "Chia cổ phần và pha loãng", tool: "cap-table" },
    ],
    icon: "↗",
  },
  {
    id: "docs",
    number: "03",
    title: "Chuẩn bị hồ sơ",
    desc: "Pitch deck, số liệu tài chính và giấy tờ pháp lý cần có.",
    tool: "pitch-deck",
    links: [
      { label: "Chấm pitch deck", tool: "pitch-deck" },
      { label: "Gửi deck để được nhận xét", to: "/nhan-xet-deck" },
      { label: "Mẫu tài chính (Excel)", to: "/mau" },
      { label: "Hồ sơ pháp lý cần có", tool: "legal-checklist" },
    ],
    icon: "▤",
  },
  {
    id: "ready",
    number: "04",
    title: "Chưa biết bắt đầu từ đâu",
    // Nhóm người dùng chính của website là founder gọi vốn lần đầu, nên thẻ này
    // được làm nổi hơn ba thẻ còn lại.
    noiBat: true,
    desc: "Rà nhanh để biết việc nào cần làm trước, và nên vào trạm nào.",
    tool: "readiness-score",
    links: [
      { label: "Chấm mức sẵn sàng", tool: "readiness-score" },
      { label: "Đọc hướng dẫn gọi vốn lần đầu", to: "/huong-dan/goi-von-lan-dau" },
    ],
    icon: "◎",
  },
];
export const NEXT = {
  "readiness-score": ["pitch-deck", "legal-checklist", "raise-planner"],
  runway: ["raise-planner", "unit-economics-check", "fund-match"],
  "raise-planner": ["round-simulator", "pitch-deck", "fund-match"],
  "founder-equity-split": ["cap-table", "safe-convert", "legal-checklist"],
  "cap-table": ["safe-convert", "round-simulator", "legal-checklist"],
  "round-simulator": ["cap-table", "raise-planner", "safe-convert"],
  "safe-convert": ["cap-table", "legal-checklist", "raise-planner"],
  "fund-match": ["readiness-score", "pitch-deck", "legal-checklist"],
  "term-sheet": ["cap-table", "legal-checklist", "round-simulator"],
  "pitch-deck": ["market-sizing", "raise-planner", "fund-match"],
  "legal-checklist": ["founder-equity-split", "cap-table", "fund-match"],
  "market-sizing": ["valuation-preseed", "pitch-deck", "fund-match"],
  "valuation-preseed": ["round-simulator", "raise-planner", "pitch-deck"],
  "valuation-revenue": ["round-simulator", "cap-table", "fund-match"],
  "unit-economics-check": ["runway", "raise-planner", "pitch-deck"],
  "growth-metrics": ["valuation-revenue", "pitch-deck", "unit-economics-check"],
};
